<template>
    <template v-if="footer">
        <div class="footer-slices">
            <SliceZone :slices="footer.data.slices" :components="components" />
        </div>

        <div class="copyright">
            <p>© {{ currentYear }} MALT. ALL RIGHTS RESERVED.</p>
        </div>
    </template>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {usePrismicDocument} from '@navbar-unlogged/composables';
    import {components} from '@navbar-unlogged/slices';
    import type {PrismicDocument} from '@prismicio/types';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {usePrismicLang} from '#imports';

    interface Props {
        prismicDocument?: PrismicDocument;
    }
    const props = defineProps<Props>();
    const {lang} = usePrismicLang();

    const footer = ref<PrismicDocument | undefined | null>(props.prismicDocument);
    if (!props.prismicDocument) {
        const {data} = await useAsyncData('malt-footer', () => usePrismicDocument('malt-footer', lang.value), {deep: true});
        footer.value = data.value;
    }

    const currentYear = new Date().getFullYear();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .footer-slices {
        display: flex;
        justify-content: flex-end;
        gap: 50px;

        > section {
            flex: 1;
        }

        @include mq.screen_sm {
            flex-direction: column;
            gap: var(--joy-core-spacing-6);

            > section {
                border-bottom: 1px solid color-mix(in srgb, var(--joy-color-neutral-50) 30%, transparent);
                flex: unset;

                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }

    .copyright {
        display: flex;
        justify-content: space-between;
        margin: 60px 0;
        font-weight: var(--joy-font-weight-normal);
        font-size: var(--joy-font-size-primary-300);
        line-height: var(--joy-line-height-large);
        text-transform: uppercase;
        font-family: var(--joy-font-family-base);
        color: var(--joy-color-text-default);

        @include mq.screen_sm {
            flex-direction: column;
            margin: 16px 0 0;
        }
    }
</style>
